// extracted by mini-css-extract-plugin
export default {"AvatarWithName":"SSjmI","AvatarWithName__avatarMargin":"cO78F","AvatarWithName__firstLine":"aj6N7","AvatarWithName__secondLine":"HVkBv"};